import common from './common.json';

const namespaces = {
  common,
};

export default namespaces;
